import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Charges extends Component {
  render() {
    return (
      <EntityList apiRoute='api/charges' title='Remorque - Capacités de charge' editTitle='Capacités de charge' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Charges;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/charges.js
 **/